export type DateFormatMode = "date" | "datetime";

export function formatDate(
  ts?: number | Long | null,
  mode: DateFormatMode = "datetime"
) {
  if (ts == null) return "-";
  const raw = Number(ts as any);
  const ms = raw < 1e12 ? raw * 1000 : raw;
  const d = new Date(ms);
  if (isNaN(d.getTime())) return "-";

  const pad = (n: number) => String(n).padStart(2, "0");
  const dd = pad(d.getDate());
  const mm = pad(d.getMonth() + 1);
  const yy = pad(d.getFullYear() % 100);

  if (mode === "date") {
    // Format: DD.MM.YY
    return `${dd}.${mm}.${yy}`;
  }

  const hh = pad(d.getHours());
  const min = pad(d.getMinutes());
  // Format: DD.MM.YY HH:MM (local time)
  return `${dd}.${mm}.${yy} ${hh}:${min}`;
}
